var render = function render(){var _vm=this,_c=_vm._self._c;return _c('entity',{attrs:{"entity":"contexts","presentation":"plantuml","params":{ 'dh-context-id': _vm.context }}})
}
var staticRenderFns = []

export { render, staticRenderFns }